module.exports = __webpack_public_path__ + "static/media/stars-four-point-seven-five.12680988.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/components/resources/stars-four-point-seven-five.svg
// module id = 3445
// module chunks = 0